(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suite365-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('suite365-carousel')){
  customElements.define('suite365-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.dataset.ready)return;
      this.dataset.ready='true';this.index=0;this.slides=[...this.querySelectorAll('.s365-carousel__slide')];
      this.track=this.querySelector('.s365-carousel__track');this.pauseButton=this.querySelector('[data-pause]');
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.motion.matches;this.hovered=false;
      this.abort=new AbortController();const opts={signal:this.abort.signal};
      this.querySelector('.s365-carousel__controls').hidden=this.slides.length<2;
      this.querySelector('[data-previous]').addEventListener('click',()=>this.show(this.index-1,true),opts);
      this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1,true),opts);
      this.querySelectorAll('[data-slide]').forEach(button=>button.addEventListener('click',()=>this.show(Number(button.dataset.slide),true),opts));
      this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.syncPause();this.schedule();},opts);
      this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.schedule();}},opts);
      this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},opts);
      this.addEventListener('focusin',e=>{if(!e.target.closest('[data-pause]')){this.paused=true;this.syncPause();this.schedule();}},opts);
      this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1),true);}},opts);
      const viewport=this.querySelector('.s365-carousel__viewport');let touchStart=null;
      viewport.addEventListener('touchstart',e=>{touchStart={x:e.touches[0].clientX,y:e.touches[0].clientY};clearTimeout(this.timer);},{...opts,passive:true});
      viewport.addEventListener('touchend',e=>{if(!touchStart)return;const x=e.changedTouches[0].clientX-touchStart.x,y=e.changedTouches[0].clientY-touchStart.y;if(Math.abs(x)>45&&Math.abs(x)>Math.abs(y))this.show(this.index+(x<0?1:-1),true);else this.schedule();touchStart=null;},{...opts,passive:true});
      document.addEventListener('visibilitychange',()=>this.schedule(),opts);
      this.motion.addEventListener('change',()=>{if(this.motion.matches){this.paused=true;this.syncPause();}this.schedule();},opts);
      this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s===e.target||s.contains(e.target));if(i>=0)this.show(i,true);},opts);
      this.show(0,false);
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();delete this.dataset.ready;}
    syncPause(){this.pauseButton.setAttribute('aria-label',this.paused?'自動切り替えを再生':'自動切り替えを停止');this.pauseButton.querySelector('[data-pause-text]').textContent=this.paused?'再生':'停止';}
    schedule(){clearTimeout(this.timer);if(!this.paused&&!this.hovered&&!document.hidden&&this.slides.length>1)this.timer=setTimeout(()=>this.show(this.index+1,false),Math.max(5000,Number(this.dataset.delay)||6500));}
    show(index,manual){
      this.index=(index+this.slides.length)%this.slides.length;if(manual)this.paused=true;
      this.track.style.transform='translateX(-'+(this.index*100)+'%)';
      this.slides.forEach((slide,i)=>{slide.inert=i!==this.index;slide.setAttribute('aria-hidden',String(i!==this.index));});
      this.querySelectorAll('[data-slide]').forEach((button,i)=>{if(i===this.index)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});
      if(manual)this.querySelector('[data-slide-status]').textContent=(this.index+1)+' / '+this.slides.length+'枚目の写真';
      this.syncPause();this.schedule();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suite365-header"]) return;
  try {
    
  const headerGroup=document.querySelector('#header-group');
  if(headerGroup){
    const measure=()=>document.documentElement.style.setProperty('--s365-nav-height',headerGroup.getBoundingClientRect().height+'px');
    measure();
    if(window.ResizeObserver)new ResizeObserver(measure).observe(headerGroup);
  }
  document.querySelectorAll('.s365-menu').forEach(menu => {
    const trigger=menu.querySelector('summary');
    document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))menu.open=false;});
    menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;trigger.focus();}});
    menu.querySelectorAll('nav a').forEach(link=>link.addEventListener('click',()=>{menu.open=false;}));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suite365-inquiry"]) return;
  try {
    
if(!customElements.get('suite365-inquiry')){
  customElements.define('suite365-inquiry',class extends HTMLElement{
    connectedCallback(){
      if(this.dataset.ready)return;this.dataset.ready='true';
      const type=this.querySelector('[data-inquiry-type]');if(!type)return;
      const query=new URLSearchParams(location.search), requested=query.get('type')||(location.pathname==='/pages/business'?'business':'product'), option=Array.from(type.options).find(o=>o.dataset.type===requested);
      if(option)type.value=option.value;
      const sync=()=>{const o=type.selectedOptions[0];this.querySelector('[data-procurement]').open=['business','custom','gift'].includes(o?.dataset.type);};
      type.addEventListener('change',sync);sync();
      const map=JSON.parse(this.querySelector('[data-choice-map]').textContent), chosen=[];
      for(const [group,key]of [['items','item'],['sizes','size'],['colors','color']]){const value=query.get(key);if(Object.prototype.hasOwnProperty.call(map[group],value))chosen.push(map[group][value]);}
      const measure = key => { const raw = query.get(key); if (!raw || !/^\d{1,3}(?:\.\d)?$/.test(raw)) return null; const value = Number(raw); return value >= 1 && value <= 999 ? value : null; };
      const width = measure('width'), length = measure('length');
      if (width !== null && length !== null) {
        const measured = this.dataset.measuredLabel + ' ' + width + ' × ' + length + ' cm';
        chosen.push(measured);
        const sizeField = this.querySelector('input[name="contact[希望寸法]"]');
        if (sizeField && !sizeField.value) sizeField.value = measured;
        this.querySelector('[data-procurement]').open = true;
      }
      if(chosen.length){const text=chosen.join(' / ');const note=this.querySelector('[data-selection-note]');note.textContent=text;note.hidden=false;this.querySelector('[data-selection-value]').value=text;}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suite365-signup"]) return;
  try {
    
  if(!customElements.get('suite365-signup')){
    customElements.define('suite365-signup',class extends HTMLElement{
      connectedCallback(){
        if(this.dataset.ready)return;this.dataset.ready='true';
        const fields=[['[data-interest]','interest','item'],['[data-interest-size]','size','size'],['[data-interest-color]','color','color']];
        const query=new URLSearchParams(location.search);
        for(const [selector,,param] of fields){const el=this.querySelector(selector);if(!el)continue;el.disabled=false;const value=query.get(param);if(value&&Array.from(el.options).some(o=>o.value===value))el.value=value;}
        const update=()=>{const tags=['newsletter','suite365-launch'];for(const [selector,key]of fields){const el=this.querySelector(selector);if(el)tags.push('s365-'+key+'-'+el.value);}const input=this.querySelector('[data-signup-tags]');if(input)input.value=tags.join(',');};
        const product=this.querySelector('[data-interest]');
        const sync=()=>{const size=this.querySelector('[data-interest-size]');const color=this.querySelector('[data-interest-color]');if(!product||!size||!color)return;const notSized=['all','bath','gift'].includes(product.value);if(notSized)size.value='undecided';else if(product.value==='pillow')size.value='pillow';else if(size.value==='pillow')size.value='undecided';size.disabled=notSized||product.value==='pillow';if(notSized)color.value='undecided';color.disabled=notSized;size.parentElement.hidden=notSized||product.value==='pillow';color.parentElement.hidden=notSized;product.parentElement.classList.toggle('s365-wide',notSized);update();};
        this.addEventListener('change',sync);sync();
        const form=this.querySelector('form');
        if(!form||!window.fetch||!window.DOMParser)return;
        if(form.dataset.hcaptchaBound||form.dataset.recaptchaBound)return;
        const send=async()=>{
          if(this.dataset.busy==='true'||this.dataset.submitted==='true')return;
          const submit=form.querySelector('button[type="submit"]');
          if(!submit)return;
          update();
          const body=new URLSearchParams(new FormData(form));
          const action=new URL(form.action,location.href);action.hash='';
          const height=form.getBoundingClientRect().height;
          const fallback=form.querySelector('[data-submit-error]').content.cloneNode(true);
          this.dataset.busy='true';form.setAttribute('aria-busy','true');submit.disabled=true;
          form.querySelectorAll('[data-s365-errors]').forEach(error=>error.remove());
          try{
            const response=await fetch(action.href,{method:'POST',body,credentials:'same-origin',headers:{Accept:'text/html'}});
            if(new URL(response.url).pathname.startsWith('/challenge')){
              HTMLFormElement.prototype.submit.call(form);return;
            }
            const page=new DOMParser().parseFromString(await response.text(),'text/html');
            const result=page.getElementById(form.id);
            const success=result&&result.querySelector('[data-s365-success]');
            if(response.ok&&success){
              form.style.minHeight=height+'px';form.style.display='flex';form.style.flexDirection='column';
              form.replaceChildren(document.importNode(success,true));
              this.dataset.submitted='true';
              const notice=form.querySelector('[data-s365-success]');
              const header=document.querySelector('#header-group');
              const top=(header?header.getBoundingClientRect().bottom:0)+16;
              const offset=Math.max(0,Math.min(height-notice.getBoundingClientRect().height,top-form.getBoundingClientRect().top));
              notice.style.marginTop=offset+'px';notice.focus({preventScroll:true});
              const privacy=window.Shopify&&Shopify.customerPrivacy;
              if(privacy&&privacy.analyticsProcessingAllowed&&privacy.analyticsProcessingAllowed()&&Shopify.analytics&&Shopify.analytics.publish){
                try{Shopify.analytics.publish('form_success',{form_kind:'launch_signup'});}catch{}
              }
            }else{
              const error=result&&result.querySelector('[data-s365-errors]');
              form.prepend(error?document.importNode(error,true):fallback);
              form.querySelector('[data-s365-errors]').focus({preventScroll:true});
            }
          }catch{
            form.prepend(fallback);
            form.querySelector('[data-s365-errors]').focus({preventScroll:true});
          }finally{
            delete this.dataset.busy;form.removeAttribute('aria-busy');submit.disabled=false;
          }
        };
        form.submit=send;
        form.addEventListener('submit',event=>{
          event.preventDefault();
          if(this.dataset.busy==='true'||this.dataset.submitted==='true'){event.stopImmediatePropagation();return;}
          if(form.dataset.hcaptchaBound||form.dataset.recaptchaBound)return;
          const captcha=window.Shopify&&Shopify.captcha;
          if(captcha&&captcha.protect)captcha.protect(form,()=>form.submit());
          else send();
        },true);
        const captcha=window.Shopify&&Shopify.captcha;
        if(captcha&&captcha.protect)captcha.protect(form);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suite365-size-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('suite365-size-finder')) {
    customElements.define('suite365-size-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const form = this.querySelector('form');
        const productLink = this.querySelector('[data-product-link]');
        const inquiryLink = this.querySelector('[data-inquiry-link]');
        const resetLinks = () => { productLink.href = '/#suite365-collection'; inquiryLink.href = '/pages/contact?type=custom'; };
        form.querySelector('button').disabled = false;
        form.addEventListener('submit', event => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          const width = Number(form.elements.namedItem('width').value);
          const length = Number(form.elements.namedItem('length').value);
          const key = length === 210 ? ({150: 'single', 190: 'double', 210: 'queen'})[width] : undefined;
          this.querySelector('[data-result]').textContent = key ? this.dataset.match.replace('{size}', this.querySelector('[data-' + key + ']').textContent) : this.dataset.custom;
          const params = new URLSearchParams({type:key ? 'product' : 'custom',item:'cover',size:key || 'custom',width:String(width),length:String(length)});
          inquiryLink.href = '/pages/contact?' + params.toString();
          productLink.href = key ? '/?item=cover&size=' + key + '#s365-product-cover' : '/#suite365-collection';
        });
        form.addEventListener('input', () => {
          resetLinks();
          this.querySelector('[data-result]').textContent = this.querySelector('[data-result]').dataset.initial;
        });
        const result = this.querySelector('[data-result]');
        result.dataset.initial = result.textContent;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
